import { SubmissionError } from 'redux-form';
import { get, intersection } from 'lodash';

import createAsyncAction from 'shared/utils/createAsyncAction';
import { addToast } from 'modules/messageSystem/actions/addToast';
import { apiErrorHandler } from 'shared/utils/apiErrorHandler';

import createAction from './';
import { login } from './login';
import { handleCommonErrors } from './commonErrors';
import { startLockdown } from './lockdown';
import {
  LOGIN_FREEZED_DUE_TO_MANY_ATTEMPTS,
  POLICY_ID_NOT_FOUND,
  INVALID_SECONDARY_CREDENTIALS,
  INVALID_CREDENTIALS,
  apiErrorMessagesMap,
} from '../constants/apiErrorCodes';

export const PHONE_NUMBER_LENGTH = 10;
export const INTERNAL_WITH_PHONE = 'INTERNAL_WITH_PHONE';

export const ADD_LOCAL_ERROR_CODE = createAction('ADD_LOCAL_ERROR_CODE');
export const FLUSH_ERRORS = createAction('FLUSH_ERRORS');
export const SUBMIT_LOGIN_FORM = createAsyncAction(createAction('SUBMIT_LOGIN_FORM'));

const knownErrorCodes = Object.keys(apiErrorMessagesMap).map(Number);

const knownErrors = [
  ...knownErrorCodes,
  LOGIN_FREEZED_DUE_TO_MANY_ATTEMPTS,
];

export const submitLoginForm = (data, isExtendedLogin, captchaToken) => (dispatch, getState) => {
  dispatch({ type: SUBMIT_LOGIN_FORM.pending });

  return dispatch(login(data, isExtendedLogin, captchaToken))
    .then(() => dispatch({ type: SUBMIT_LOGIN_FORM.success }))
    .catch((apiError) => {
      const apiErrorCodes = apiError.graphQLErrors.map(error => get(error, 'extensions.code'), 500).map(Number);
      const isLastLoginFailedAttempt = apiError.graphQLErrors.some(error => get(error, 'extensions.properties.isLastLoginFailedAttempt'));
      const loginError = get(getState(), 'auth.organizations.loginConfig.loginErrorText');
      const apiErrorMessagesMapCopy = { ...apiErrorMessagesMap };

      dispatch({
        type: SUBMIT_LOGIN_FORM.failure,
        payload: {
          apiErrorCodes,
          isLastLoginFailedAttempt,
        },
      });

      const handledErrorCodes = intersection(apiErrorCodes, knownErrors);
      if (handledErrorCodes.length === 0) {
        dispatch(handleCommonErrors(apiErrorCodes));
      }

      if (apiErrorCodes.includes(POLICY_ID_NOT_FOUND)) {
        return dispatch(addToast('info', 'user-not-found-toast', {
          id: 'Authentication.Login.Error.NoUserFound',
          defaultMessage: '** Please contact Femi\'s call-center and set up an appointment.',
        }));
      }

      if (apiErrorCodes.includes(LOGIN_FREEZED_DUE_TO_MANY_ATTEMPTS)) {
        const unfreezeTimestamp = get(apiError.graphQLErrors, '[0].extensions.properties.unfreezeTimestamp');
        return dispatch(startLockdown(unfreezeTimestamp));
      }

      if (isExtendedLogin) {
        throw new SubmissionError({ _error: loginError || apiErrorMessagesMapCopy[INVALID_SECONDARY_CREDENTIALS] });
      }

      if (loginError) {
        throw new SubmissionError({ [apiErrorMessagesMapCopy[INVALID_CREDENTIALS].field]: loginError });
      }

      throw new SubmissionError(apiErrorHandler(apiError, true, apiErrorMessagesMapCopy, false));
    });
};
